import React, { useState } from "react";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Trans } from "react-i18next";
import i18n from '../../i18n';

import {
  Callout,
  Card,
  Tag,
  Switch,
  Icon,
  Checkbox,
  Button,
  Popover,
  Classes
} from "@blueprintjs/core";

import { authenticatedPostFetch, getBackendRoute } from "../../utils/AuthenticatedFetch";
import { EditableDate, EditableNumber } from "../Structure/Editables";


/* {
  id: 1,
  lbl: 'PARC 1',
  subPark: 0,
  mainPark: 0,
  on_fire: false,
  full: false,
  forced_full: true,
  closed: false,
  forced_closed: 1,
  crossing_time: 2,
  leaving_time: 0,
  dateReprise: '1641384960'
} */

function Park(props) {
  const [crossing_time, setCrossing_time] = useState(props.crossing_time);
  const [leaving_time, setLeaving_time] = useState(props.leaving_time);
  const [dateReprise, setDateReprise] = useState(props.dateReprise);

  const now = new Date();
  const tendaysago = new Date().setDate(now.getDate() - 10);
  const inhundreddays = new Date().setDate(now.getDate() + 100);
  
  return (
    <Card className="myCard">
      <div className="flexbox-left">
        <Tag large={true}>{props.lbl}</Tag>
        {props.full ?
          <Tag intent="warning" icon="warning-sign"><Trans>full</Trans></Tag> : null}
        {props.closed ?
          <Tag intent="warning" icon="warning-sign"><Trans>closed</Trans></Tag> : null}
        {props.on_fire ?
          <Tag intent="danger" icon="error"><Trans>on fire</Trans></Tag> : null}
        {!props.on_fire && !props.full && !props.closed ?
          <Tag intent="success" icon="tick"><Trans>normal behaviour</Trans></Tag> : null}
      </div>

      <div className="flexbox-left">
        <Checkbox
          checked={!props.forced_full}
          label={i18n.t("automatic management")}
          onChange={(cb) => { authenticatedPostFetch('/park/controlFull', { srv: props.server, park: props.id, value: !cb.target.checked }) }}
        />
        <Switch
          disabled={!props.forced_full}
          checked={props.full}
          label={i18n.t("full")}
          onChange={(cb) => {
            cb.target.checked ?
              authenticatedPostFetch('/park/full', { srv: props.server, park: props.id })
              : authenticatedPostFetch('/park/notfull', { srv: props.server, park: props.id })
          }}
        />
      </div>

      <div className="flexbox-left">
        <Checkbox
          checked={!props.forced_closed}
          label={i18n.t("automatic management")}
          onChange={(cb) => { authenticatedPostFetch('/park/controlClosed', { srv: props.server, park: props.id, value: !cb.target.checked }) }}
        />
        <Switch disabled={!props.forced_closed}
          checked={props.closed}
          label={i18n.t("closed")}
          onChange={(cb) => {
            cb.target.checked ?
              authenticatedPostFetch('/park/close', { srv: props.server, park: props.id })
              : authenticatedPostFetch('/park/open', { srv: props.server, park: props.id })
          }}
        />
      </div>

      <div className="flexbox-center-large">
        <Switch
          label={<span>{i18n.t("verrou pompier")} <Icon icon="flame" intent={props.on_fire ? "danger" : "normal"} /></span>}
          checked={props.on_fire}
          onChange={(cb) => {
            authenticatedPostFetch('/park/fire', { srv: props.server, park: props.id, value: cb.target.checked })
          }}
        />

        <Popover
          content={
            <div>
              <Callout intent="primary">
                <div>
                  <Trans>crossing time:</Trans> <EditableNumber value={crossing_time} unit="minute" min={0} max={99}
                    handleValue={(value) => authenticatedPostFetch('/park/crossingtime', {
                      srv: props.server,
                      park: props.id,
                      value: value
                    }, (res)=>{
                      if(res === 200) setCrossing_time(value);
                    })} />
                </div>
                <div>
                  <Trans>leaving time:</Trans> <EditableNumber value={leaving_time} unit="minute" min={0} max={99}
                    handleValue={(value) => authenticatedPostFetch('/park/leavingtime', {
                      srv: props.server,
                      park: props.id,
                      value: value
                    }, (res)=>{
                      if(res === 200) setLeaving_time(value);
                    })} />
                </div>
                <div>
                  <Trans>date de reprise:</Trans>
                  <EditableDate
                    value={new Date(dateReprise)}
                    unit="minute"
                    min={tendaysago}
                    max={inhundreddays}
                    handleValue={(value) => authenticatedPostFetch('/park/reprise', {
                      srv: props.server,
                      park: props.id,
                      value: value
                    }, (res)=>{
                      if(res === 200) setDateReprise(value);
                    })}
                  />
                </div>
                <Button className={Classes.POPOVER_DISMISS} text={i18n.t("close")} icon="cross" />
              </Callout>
            </div>
          }
          interactionKind="click"
        >
          <Button intent="primary" text={i18n.t("more info")} icon="info-sign" />

        </Popover>
      </div>
    </Card >
  );
}

export default class Parks extends React.Component {
  constructor(props) {
    super();
    this.state = {
      loaded: false,
      parks: {},
      groupFilter: props.groupFilter || ""
    };
  }

  handleParkMessage(message) {
    try {
      const parsedmsg = JSON.parse(message.data);
      if (parsedmsg.id !== undefined && parsedmsg.lbl !== undefined && parsedmsg.on_fire !== undefined && parsedmsg.full !== undefined && parsedmsg.forced_full !== undefined && parsedmsg.closed !== undefined && parsedmsg.forced_closed !== undefined) {
        var newState = Object.assign({}, this.state);   // Clone the park state obj in newState
        newState.parks[parsedmsg.pk] = parsedmsg;
        this.setState({ loaded: true, ...newState });
      }
    }
    catch (e) {
      console.error("cannot parse" + message.data);
      console.log("ERROR", e);
    }
  }

  componentDidMount() {
    this.client = new W3CWebSocket(getBackendRoute("WS") + "/supervision/parks" + this.state.groupFilter, ["Bearer", localStorage.getItem('token')]);
    this.client.onmessage = (message) => this.handleParkMessage(message);
  }

  componentWillUnmount() {
    if (this.client !== undefined)
      this.client.close();
  }

  render() {
    const parks = [];
    for (var parkId in this.state.parks) {
      parks.push(<Park key={"pk" + this.state.parks[parkId].pk} {...this.state.parks[parkId]} />);
    };

    return (
      parks.length > 0 ?
        <Callout title={<Trans>parks</Trans>}>
          <div className="flexbox-left">{parks}</div>
        </Callout>
        : null
    );
  }
}
